import * as IObjects from '../../../Interfaces/objects';
import { useEffect, useState } from 'react';
const useForm = (callback: Function, validate: Function) => {
    const [values, setValues] = useState<IObjects.GenericObj>({});
    const [errors, setErrors] = useState({});
    const [submissionAttempt, setSubmissionAttempt] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        if (Object.keys(errors).length === 0 && isSubmitting) {
            callback(values);
            setIsSubmitting(false); //So we don't submit every time we validate without errors
        } else {
            setIsSubmitting(false); //So we don't submit every time we validate without errors
        }
        // eslint-disable-next-line
    }, [errors]);

    useEffect(() => {
        //Only validate after every field change after submission attempt, so we don't display validation errors before field has been touched.
        if (submissionAttempt > 0) {
            setErrors(validate(values));
        }
        // eslint-disable-next-line
    }, [values]);
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        if (event) event.preventDefault();
        setSubmissionAttempt(submissionAttempt + 1);
        setErrors(validate(values));
        setIsSubmitting(true);
    };
    const triggerValidation = () => {
        setErrors(validate(values));
    };

    //Supports text, select and toggle/checkbox
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.persist) event.persist();
        //TODO the following should be cleaned up!
        switch (event.target.name){
            case "isAd":
                setValues({...values, isNameHidden:true, isAd: event.target.checked})
                break;
            case "ads":
                if(event.target.value){
                    setValues({...values, isNameHidden:true, ads: event.target.value})
                }
                break;

            default:
                setValues(values => ({
                    ...values,
                    [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
                }));
                break;
        }
    };

    return {
        errors,
        handleChange,
        handleSubmit,
        setValues,
        values,
        triggerValidation,
    };
};

export default useForm;
